import React from "react";
import PropTypes from "prop-types";

export const CheckIcon = ({ width = 16, height = 12, className = "" }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 16 12"
      fill="none"
      className={className}
    >
      <path
        d="M14.9993 1L5.83268 10.1667L1.66602 6"
        stroke="#2258F1"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

CheckIcon.propTypes = {
  width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  height: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  className: PropTypes.string,
};
